import { useAuth } from "contexts/auth";
import { Page } from "v2/components";
import { BuscaPessoa } from "v2/components/BuscaPessoa";

import { CollaboratorsSummary } from "./CollaboratorsSummary";
import { CollaboratorsTotal } from "./CollaboratorsTotal";
import { CarteirinhasTab } from "./CarteirinhasTab/CarteirinhasTab";
import { DocumentosTab } from "./DocumentosTab/DocumentosTab";
import { CollaboratorsElegible } from "./CollaboratorsElegible";
import { CollaboratorsMovements } from "./CollaboratorsMovements";

export function Collaborators() {
  const { user } = useAuth();
  // A busca é do RH (comprador); a corretora não tem empresa da sessão para buscar (spec do RH §7).
  const busca = user && !user.isSeller && !user.isAdmin ? <BuscaPessoa /> : null;

  return (
    <Page title="Colaboradores" headerExtra={busca}>
      <Page.Tab name="Resumo" variant="free">
        <CollaboratorsSummary />
      </Page.Tab>
      <Page.Tab name="Cadastro">
        <CollaboratorsTotal />
      </Page.Tab>
      <Page.Tab name="Carteirinhas">
        <CarteirinhasTab />
      </Page.Tab>
      <Page.Tab name="Documentos">
        <DocumentosTab />
      </Page.Tab>
      {/* <Page.Tab name="Elegíveis" disabled>
        <CollaboratorsElegible />
      </Page.Tab>
      <Page.Tab name="Massa Movimentada" disabled>
        <CollaboratorsMovements />
      </Page.Tab> */}
    </Page>
  );
}
